import { isWeb } from '@zonofi/common';
import { CategoryTreeItem, Products } from './model';
import {
  ListFilterKeys,
  ListInputItemOptions,
  Mappings,
  MobileSiftScreen,
  TreeFilterInput,
  TreeFilterKeys,
  TreeInputData,
} from '../filter/model';
import { createListFiltersData, mapDataToInputItems } from '../filter/helpers';
import {
  addListInputItems,
  updateMobileFiltersByScreen,
} from '../filter/slice';
import { UnknownAction } from 'redux';
import { ThunkDispatch } from '@reduxjs/toolkit';

export const handleProductListFilters = (
  dispatch: ThunkDispatch<any, any, UnknownAction>,
  data: Products
) => {
  if (isWeb()) {
    const divisionInputItems = mapDataToInputItems(
      data?.divisionSummary,
      'divisionId',
      'name'
    );
    dispatch(
      addListInputItems({
        inputItems: divisionInputItems,
        key: ListInputItemOptions.divisions,
      })
    );
    const cfaInputItems = mapDataToInputItems(
      data?.cfaSummary,
      'cfaId',
      'supplierName'
    );

    const segmentInputItems = mapDataToInputItems(
      data?.segmentsSummary,
      'segmentId',
      'segmentName'
    );

    dispatch(
      addListInputItems({
        inputItems: segmentInputItems,
        key: ListInputItemOptions.ProductSegments,
      })
    );

    dispatch(
      addListInputItems({
        inputItems: cfaInputItems,
        key: ListInputItemOptions.cfa,
      })
    );
    const categories = data?.categoryCodes;
    const categoryInputItems = mapDataToInputItems(
      categories,
      'categoryCode',
      'categoryName'
    );
    dispatch(
      addListInputItems({
        inputItems: categoryInputItems,
        key: ListInputItemOptions.categories,
      })
    );
  } else {
    const mappings: Mappings<Products>[] = [
      {
        dataKey: 'divisionSummary',
        idKey: 'divisionId',
        valueKey: 'name',
        filterKey: ListFilterKeys.Divisions,
      },
      {
        dataKey: 'cfaSummary',
        idKey: 'cfaId',
        valueKey: 'supplierName',
        filterKey: ListFilterKeys.Cfa,
      },
    ];

    const listFilter = createListFiltersData(data, mappings);
    const treeFilter: Partial<TreeFilterInput> = {
      [TreeFilterKeys.ProductStatus]: {
        applyParent: true,
        value: [
          {
            id: 'segments',
            value: 'Segments',
            selected: false,
            data:
              data?.segmentsSummary?.map(({ segmentId, segmentName }) => ({
                id: segmentId,
                value: segmentName,
                selected: false,
              })) ?? [],
          },
          {
            id: 'categories',
            value: 'Categories',
            selected: false,
            data: convertToTreeInput(data.categoryTree, '__root_category__'),
          },
        ] as TreeInputData[],
      },
    };

    dispatch(
      updateMobileFiltersByScreen({
        screen: MobileSiftScreen.PRODUCTS,
        filter: { listFilter, treeFilter },
      })
    );
  }
};

const convertToTreeInput = (
  input: CategoryTreeItem[],
  root: string,
  seen = new Set<string>()
): TreeInputData[] => {
  const data: TreeInputData[] = [];

  input.forEach(({ categoryCode, children, name }) => {
    if (!name || seen.has(categoryCode)) return;

    seen.add(categoryCode);

    if (children.length) {
      const childrenData = convertToTreeInput(children, root, seen);
      if (name === root) {
        data.push(...childrenData);
      } else {
        data.push({
          id: categoryCode,
          value: name,
          selected: false,
          data: childrenData,
        });
      }
    } else {
      data.push({
        id: categoryCode,
        value: name,
        selected: false,
      });
    }
  });

  return data;
};
